<template>
    <div>
        <div v-if="membership" class="card br row m-b-6">
            <div class="column">
                <div class="card-content row row-collapse-indent row-middle m-t-4 m-b-4">
                    <div class="slat-content column">
                        <h4 class="card-title c-primary f-s-4 m-b-0">{{ membership.name }}</h4>
                        <div class="card-type f-s-2 c-muted m-t-1">{{ membershipProducts(membership) }}</div>
                    </div>
                    <div class="slat-aside text-right m-r-4">
                        <a v-on:click.prevent="deleteMembership" class="i-container i-filled-dark btn btn-text width-auto-min p-0 m-r-0" href="#remove-membership">
                            <!-- /icons/remove.svg -->
                            <svg class="icon i-size-medium" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle fill="#FFF" cx="16" cy="16" r="16"/><path fill="#AAB2BD" fill-rule="nonzero" d="M23 10.41L21.59 9 16 14.59 10.41 9 9 10.41 14.59 16 9 21.59 10.41 23 16 17.41 21.59 23 23 21.59 17.41 16z"/></g></svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <input type="hidden" name="sales_popup_membership_id" v-bind:value="membership ? membership.encoded_id : null">

        <div v-if="membership">
            <div v-if="selectedMembershipSalesPopups.length > 0" class="form-group">
                <label>{{ trans('Select Sales Popup') }}</label>
                <select class="form-control" name="sales_popup_id" v-model="salesPopupId">
                    <option v-bind:value="null">{{ trans('-- Select a sales popup --') }}</option>
                    <option v-for="popup in selectedMembershipSalesPopups" v-bind:value="popup.encoded_id" v-bind:key="popup.encoded_id">{{ popup.name }}</option>
                </select>
            </div>
            <a v-else v-bind:href="salesPopupCreateLink" class="btn btn-smaller btn-secondary f-s-2">{{ trans('Create the first sales popup') }}</a>
            <div v-if="salesPopupId" class="row row-right">
                <a v-bind:href="salesPopupEditLink" class="btn btn-smaller btn-secondary f-s-2">{{ trans('Edit Sales Popup') }}</a>
            </div>
        </div>



        <div v-if=" ! membership" class="text-center">
            <button v-on:click="addMembership" type="button" class="btn btn-text btn-text--accent btn-icon m-b-4">
                <span class="icon i-container i-filled-accent">
                    <!-- /icons/add.svg -->
                    <svg class="icon i-size-small inline" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g class="icon"><path d="M11 5v14h2V5z"/><path d="M19 11H5v2h14z"/></g></svg>
                </span>
                {{ trans('Add Membership') }}
            </button>
        </div>
        <div v-if="errors.has('sales_popup_membership_id')" class="form-help c-error has-error">
            {{ errors.get('sales_popup_membership_id') }}
        </div>
        <div v-else-if="errors.has('sales_popup_id')" class="form-help c-error has-error" v-bind:class="{'m-t-5': membership && selectedMembershipSalesPopups.length === 0}">
            {{ errors.get('sales_popup_id') }}
        </div>

        <membership-picker-modal
            v-bind:memberships="filteredMemberships"
            v-on:close="modal.show = false"
            v-on:select-membership="selectMembership"
            ref="membership-picker-modal"
        ></membership-picker-modal>
    </div>
</template>
<script>
import HasMembershipProducts from '../../mixins/HasMembershipProducts';
import MembershipPickerModal from '../memberships/MembershipPickerModal.vue';
import Errors from '../../errors';
import { EventBus } from '../../event-bus';
import { scrollToError } from '../../helpers';

export default {
    components: {
        MembershipPickerModal,
    },
    mixins: [
        HasMembershipProducts,
    ],
    props: {
        memberships: {
            type: Array,
        },
        salesPopups: {
            type: Array,
        },
        selectedMembership: {
            type: String,
            default: null,
        },
        selectedSalesPopup: {
            type: String,
            default: null,
        },
        validationErrors: {
            type: [Array, Object]
        },
    },
    data() {
        return {
            membership: null,
            salesPopup: null,
            salesPopupId: null,
            selectedMembershipSalesPopups: this.salesPopups || [], // This holds the sales popups of the currently selected membership
            errors: new Errors(this.validationErrors),
            modal: null,
        }
    },
    computed: {
        filteredMemberships() {
            if ( ! this.membership) {
                return this.memberships;
            }

            return this.memberships.filter((membership) => {
                return this.membership.encoded_id !== membership.encoded_id;
            });
        },
        salesPopupCreateLink() {
            if ( ! this.membership) {
                return '#';
            }

            return window.Kourses.activeBaseUrl + '/memberships/' + this.membership.encoded_id + '/sales-popups?return=' + encodeURIComponent(window.location.pathname) + '#create-sales-popup';
        },
        salesPopupEditLink() {
            if ( ! this.membership || ! this.salesPopup) {
                return '#';
            }

            return window.Kourses.activeBaseUrl + '/memberships/' + this.membership.encoded_id + '/sales-popups?return=' + encodeURIComponent(window.location.pathname) + '#edit-sales-popup-' + this.salesPopup.encoded_id;
        },
    },
    methods: {
        addMembership() {
            this.modal.show = true;
        },
        selectMembership(membership) {
            this.modal.show = false;
            this.membership = membership;
            this.errors.clear();
            EventBus.$emit('form:element:changed', 'sales_popup_membership_id', this.membership ? this.membership.encoded_id : null);
            EventBus.$emit('form:element:changed', 'sales_popup_id', null);

            this.laodSalesPopups(membership);
        },
        deleteMembership() {
            this.membership = null;
            this.salesPopup = null;
            this.salesPopupId = null;
            this.errors.clear();
            EventBus.$emit('form:element:changed', 'sales_popup_membership_id', this.membership ? this.membership.encoded_id : null);
        },
        laodSalesPopups(membership) {
            window.axios.get(window.Kourses.apiBaseUrl + '/memberships/' + membership.encoded_id + '/sales-popups')
                .then((response) => {
                    this.selectedMembershipSalesPopups = response.data.data;
                });
        }
    },
    created() {
        if (this.selectedMembership) {
            this.membership = this.memberships.find(membership => membership.encoded_id === this.selectedMembership);
        }

        if (this.selectedSalesPopup) {
            this.salesPopup = this.salesPopups.find(popup => popup.encoded_id === this.selectedSalesPopup);

            // Covers scenario when we had sales popup previously but selected a different membership and saved
            if (this.salesPopup) {
                this.salesPopupId = this.selectedSalesPopup;
            }
        }
    },
        mounted() {
        this.modal = this.$refs['membership-picker-modal'];

        this.$nextTick(() => {
            EventBus.$emit('form:element:initialize', 'sales_popup_membership_id', this.membership ? this.membership.encoded_id : null);
            EventBus.$emit('form:element:initialize', 'sales_popup_id', this.salesPopup ? this.salesPopup.encoded_id : null);

            if (this.errors.any()) {
                scrollToError(this.$el);
            }
        });
    },
}
</script>